<template>
  <div class="style-form py-2 py-md-5">
    <div class="col-12 col-md-10 mx-auto">
      <h2 class="color-palette-2 font-weight-bold">Completa tus datos</h2>
    </div>
    <div class="col-12 col-md-10 mx-auto">
      <form id="form-referrals" class="row" @submit.prevent="sendReferralsForm" method="POST">
        <input type="hidden" name="_token" :value="csrf" />
        <input type="hidden" name="project_id" :value="form.project_id" />
        <input type="hidden" name="executive_id" :value="form.executive_id" />
        <div class="col-12 col-md-6">
          <input
            type="text"
            placeholder="Nombre"
            name="name"
            v-model.trim="$v.form.name.$model"
            :class="
              !$v.form.name.$anyError ? 'form-control w-100' : 'form-control w-100 form-error'
            "
          />
          <div class="error-data" v-if="$v.form.name.$dirty">
            <span v-if="!$v.form.name.required">Campo necesario</span>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <input
            type="text"
            placeholder="Rut"
            name="rut"
            v-model.trim="$v.form.rut.$model"
            v-rut:live
            :class="!$v.form.rut.$anyError ? 'form-control w-100' : 'form-control w-100 form-error'"
          />
          <div class="error-data" v-if="$v.form.rut.$dirty">
            <span v-if="!$v.form.rut.rutValidation || !$v.form.rut.minLength">RUT Inválido</span>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <input
            type="text"
            placeholder="Email"
            name="email"
            v-model.trim="$v.form.email.$model"
            :class="
              !$v.form.email.$anyError ? 'form-control w-100' : 'form-control w-100 form-error'
            "
          />
          <div class="error-data" v-if="$v.form.email.$dirty">
            <span v-if="!$v.form.email.required">Campo necesario</span>
            <span v-if="!$v.form.email.email">Email inválido</span>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <input
            type="text"
            placeholder="Teléfono"
            name="phone"
            maxlength="9"
            @keypress="onlyNumber"
            v-model.trim="$v.form.phone.$model"
            :class="
              !$v.form.phone.$anyError ? 'form-control w-100' : 'form-control w-100 form-error'
            "
          />
          <div class="error-data" v-if="$v.form.phone.$dirty">
            <span v-if="!$v.form.phone.required">Campo necesario</span>
            <span v-if="!$v.form.phone.minLength">Teléfono inválido</span>
            <span v-if="!$v.form.phone.maxLength">Teléfono inválido</span>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <v-select-c
            id="select-project"
            style="border-radius: 5px !important"
            v-model="$v.form.project_id.$model"
            :options="projects"
            label="name"
            :class="!$v.form.project_id.$anyError ? '' : 'form-error'"
            :reduce="(name) => name.id"
            placeholder="Proyecto que te interesó"
          >
          </v-select-c>
          <div class="error-data" v-if="$v.form.project_id.$dirty">
            <span v-if="!$v.form.project_id.required">Campo necesario</span>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <v-select-c
            id="select-executives"
            style="border-radius: 5px !important"
            v-model="$v.form.executive_id.$model"
            :options="executivesOptions"
            label="name"
            :class="!$v.form.executive_id.$anyError ? '' : 'form-error'"
            :reduce="(name) => name.id"
            placeholder="Ejecutivo que te atendió"
          >
          </v-select-c>
          <div class="error-data" v-if="$v.form.executive_id.$dirty">
            <span v-if="!$v.form.executive_id.required">Campo necesario</span>
          </div>
        </div>
        <div class="col-12">
          <privacy-consent
            id="expo-contact-privacy"
            v-model="$v.form.privacy.$model"
            :invalid="$v.form.privacy.$dirty && !$v.form.privacy.accepted"
          />
        </div>
        <div class="col-12">
          <div class="col-12 col-md-5 ml-auto pr-0 pl-0 pl-md-3">
            <button
              type="submit"
              :disabled="formLoading"
              class="btn bg-color-palette-3 text-white btn-block"
            >
              {{ btnText }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { required, minLength, email, maxLength } from 'vuelidate/lib/validators';
  import { rutValidator, rutInputDirective } from 'vue-dni';
  import PrivacyConsent from '../../components/PrivacyConsent.vue';

  import Vue from 'vue';
  Vue.directive('rut', rutInputDirective);

  const accepted = (value) => value === true;

  export default {
    name: 'form-contact-expo-vivienda',
    components: { PrivacyConsent },
    props: {
      projects: '',
      executives: '',
      ruta: '',
    },
    data: () => ({
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      formLoading: false,
      btnText: 'Enviar',
      form: {
        name: '',
        rut: '',
        email: '',
        phone: '',
        project_id: '',
        executive_id: '',
        privacy: false,
      },
    }),
    computed: {
      executivesOptions() {
        const defaultOption = { id: 'No recuerdo su nombre', name: 'No recuerdo su nombre' };
        if (!Array.isArray(this.executives)) return [defaultOption];
        return [defaultOption, ...this.executives];
      },
    },
    methods: {
      sendReferralsForm(event) {
        event.preventDefault();
        this.$v.form.$touch();
        if (!this.$v.form.$invalid) {
          this.btnText = 'Enviando...';
          this.formLoading = true;
          //const rutaForm = window.BASE_URL + '/add-contact-expo-form';
          const rutaForm = this.ruta;
          $('#form-referrals').attr('action', rutaForm).submit();
        }
      },
      onlyNumber($event) {
        let keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
          // 46 is dot
          $event.preventDefault();
        }
      },
    },
    validations: {
      form: {
        rut: {
          required,
          rutValidation: rutValidator,
          minLength: minLength(9),
        },
        name: {
          required,
        },
        phone: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(9),
        },
        email: {
          required,
          email,
        },
        project_id: {
          required,
        },
        executive_id: {
          required,
        },
        privacy: { accepted },
      },
    },
  };
</script>

<style scoped>
  .style-form {
    border-radius: 9px;
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
    background-color: #fff;
  }

  .icon-style {
    font-size: 3rem !important;
  }

  .color-text-default {
    color: #707070;
  }
</style>
